import {AlertTypeEnum} from './enums/alert-type.enum';

export class Alert {
    type: AlertTypeEnum;
    message: string;
    alertId: string;
    keepAfterRouteChange: boolean;
    phoneNumber ?: string;
    redirectInscription = false;

    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);
    }
}
